import React from 'react';

import _ from 'lodash';

const MANAGED_PROPS = ['updateModel', 'modelKey', 'value', 'blurModel'];

const withChangeHandler = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.updateModel = props.updateModel;
      this.blurModel = props.blurModel;
      this.modelKey = props.modelKey;
      this.state = {};
    }

    handleChange = (e, {value}) => {
      this.updateModel(this.modelKey, value);
      if (this.props.saveReduxOnChange === true) this.blurModel();
    };

    render = () => {
      const filteredProps = _.omit(this.props, MANAGED_PROPS);
      return (
        <WrappedComponent
          onChange={this.handleChange}
          value={this.props.value}
          onBlur={this.props.blurModel}
          {...filteredProps}
        />
      );
    };
  };
};

export default withChangeHandler;
